import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { StateService } from './../services/state.service';

interface CloneFolderResponse {
  folder_id: string;
  parallel_task_id: string;
}
@Injectable({
  providedIn: 'root'
})
export class ProjectOverviewService {
  API_URL = `${environment.baseUrl}`;
  URL = `${environment.url}`;
  USER_URL = `${environment.userUrlV3}`;
  PROCESS_URL = `${environment.expurl}`;
  PROJECT_URL = `${environment.baseUrlV3}`;
  ZONE = window.localStorage.zone;
  protected http: HttpClient;
  private API_PATH_PROJECTS = 'projects';
  private API_PATH_CREATE_PROJECTS = 'projects';
  private API_PATH_EXPERIMENTS = 'experiments';
  private API_PATH_EXPERIMENT = 'experiment';
  private API_PATH_COUNTRY = 'country?zone=' + this.ZONE;
  private API_PATH_ZONE = 'zones';
  private API_PATH_USER_ZONE = 'users/me/zones';
  private API_PATH_USER_KEY_ACCOUNT = 'users/me/key-accounts';
  private API_PATH_EXPERIMENT_PROGRESS_STATUS = 'process/';
  private API_PATH_EXPERIMENT_CLONE = '/experiments/clone';
  private API_PATH_UPDATE_EXPERIMENT_STATE = '/update_exp_state';
  private API_DOWNLOAD = 'download';
  constructor(
    http: HttpClient,
    public stateService: StateService
  ) {
    this.http = http;
  }

  ////// projects

  // get projects

  getProjects() {
    const url = `${this.API_URL}${this.API_PATH_PROJECTS}`;
    return this.http.get<any>(url).pipe(
      map((response) => {
        return response;
      })
    );
  }

  // create projects

  createProject(params: any) {
    const url = `${this.API_URL}${this.API_PATH_CREATE_PROJECTS}`;
    return this.http.post<any>(url, params).pipe(
      map((response) => {
        return response;
      })
    );
  }

  // update projects

  upDateProject(params: any, projectId: string) {
    const url = `${this.API_URL}${this.API_PATH_PROJECTS}/` + `${projectId}`;
    return this.http.put<any>(url, params).pipe(
      map((response) => {
        return response;
      })
    );
  }

  // get projects

  deleteProject(projectId: string) {
    const url = `${this.API_URL}${this.API_PATH_PROJECTS}/` + `${projectId}`;
    return this.http.delete<any>(url).pipe(
      map((response) => {
        return response;
      })
    );
  }

  ////////////// experiments

  // create Exp

  createExp(params: any, projectId: string) {
    const url = `${this.API_URL}${this.API_PATH_EXPERIMENTS}/` + `${projectId}`;
    return this.http.post<any>(url, params).pipe(
      map((response) => {
        return response;
      })
    );
  }

  // update Exp

  updateExp(params: any, projectId: string) {
    const url = `${this.API_URL}${this.API_PATH_EXPERIMENTS}/` + `${projectId}`;
    return this.http.put<any>(url, params).pipe(
      map((response) => {
        return response;
      })
    );
  }

  // get exp by project id

  getExpByProjId(projectID: string) {
    const url = `${this.API_URL}${this.API_PATH_EXPERIMENTS}/` + `${projectID}`;
    return this.http.get<any>(url).pipe(
      map((response) => {
        return response;
      })
    );
  }

  // get exp by id

  getExpById(id: string) {
    const url = `${this.API_URL}${this.API_PATH_EXPERIMENT}/` + `${id}`;
    return this.http.get<any>(url).pipe(
      map((response) => {
        return response;
      })
    );
  }

  // get exp by id

  deleteExp(id: string) {
    const url = `${this.API_URL}${this.API_PATH_EXPERIMENT}/` + `${id}`;
    return this.http.delete<any>(url).pipe(
      map((response) => {
        return response;
      })
    );
  }

  //// create projects

  // get country

  getCountry() {
    const url = `${this.URL}${this.API_PATH_COUNTRY}`;
    return this.http.get<any>(url).pipe(
      map((response) => {
        return response;
      })
    );
  }

  // get zone

  getZone() {
    const url = `${this.USER_URL}${this.API_PATH_USER_ZONE}`;
    return this.http.get<any>(url).pipe(
      map((response) => {
        return response;
      })
    );
  }
  getUserKeyAccounts() {
    const url = `${this.USER_URL}${this.API_PATH_USER_KEY_ACCOUNT}`;
    return this.http.get<any>(url).pipe(
      map((response) => {
        return response;
      })
    );
  }

  cloneExp(params: any) {
    //const url = `https://cdn.catexpert.ab-inbev.com/assets/clone.json`;
    const url = `${this.PROJECT_URL}${this.API_PATH_EXPERIMENT_CLONE}`;
    return this.http.post<any>(url, params).pipe(
      map((response) => {
        return response;
      })
    );
  }

  cloneProgressStatus(taskId: any) {
    let url = this.stateService.createProcessUrl(taskId);
    //const url = `https://cdn.catexpert.ab-inbev.com/assets/clone.json`;
    return this.http.get<any>(url).pipe(
      map((response) => {
        return response;
      })
    );
  }

  updateExperimentState(params: any) {
    const url = `${this.PROJECT_URL}${this.API_PATH_UPDATE_EXPERIMENT_STATE}`;
    return this.http.post<any>(url, params).pipe(
      map((response) => {
        return response;
      })
    );
  }

  downloadExp(params?: any, expId?: any) {
    const url = `${this.PROJECT_URL}/${this.API_PATH_EXPERIMENTS}/${expId}/${this.API_DOWNLOAD}`;
    return this.http.post<any>(url, params).pipe(
      map((response) => {
        return response;
      })
    );
  }

  progressStatus(taskId: any) {
    let url = this.stateService.createProcessUrl(taskId);
    return this.http.get<any>(url).pipe(
      map((response) => {
        return response;
      })
    );
  }

  cloneFolder(folderId: string, params: any): Observable<CloneFolderResponse> {
    const url = `${this.PROJECT_URL}/folders/${folderId}/clone`;
    return this.http.post<CloneFolderResponse>(url, params).pipe(
      map((response) => {
        return response;
      })
    );
  }
}
